import {reposWebApi} from "./customerAPI";
import {refreshToken} from "./sessionAction";

export const RATE_UPDATE = 'RATE_UPDATE';
export const IS_RATE_LOADING = 'IS_RATE_LOADING';
export const GENERAL_RATE_UPDATE = 'GENERAL_RATE_UPDATE';
export const GENERAL_AUTO_RATE_UPDATE = 'GENERAL_AUTO_RATE_UPDATE';

export const getRateUpdate = (requestBody, enqueueSnackbar, setNoti) => {

    return (dispatch) => {
        dispatch({
            type: IS_RATE_LOADING,
        });
        reposWebApi.post('/partner/refueler_rate_density_update', requestBody, {
            headers: {
                Authorization: 'Bearer ' + localStorage.access_token
            }
        })
            .then(response => {
                dispatch({
                    type: RATE_UPDATE,
                    payload: response?.data.data,
                    // .data.results,
                })
                enqueueSnackbar(response?.data.data, {
                    variant: 'success', anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    preventDuplicate: true
                });
                setNoti(true);
            })
            .catch(async error => {
                if (error.response?.status === 401) {
                    await dispatch(refreshToken(getRateUpdate()))
                }
            })
    }
};


export const getGeneralRateUpdate = (requestBody, enqueueSnackbar, setNoti) => {

    return (dispatch) => {
        dispatch({
            type: IS_RATE_LOADING,
        });
        reposWebApi.post('/partner/pump_rate_and_density_update', requestBody, {
            headers: {
                Authorization: 'Bearer ' + localStorage.access_token
            }
        })
            .then(response => {
                dispatch({
                    type: GENERAL_RATE_UPDATE,
                    payload: response?.data.data,
                    // .data.results,
                })
                enqueueSnackbar(response?.data.data, {
                    variant: 'success', anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    preventDuplicate: true
                });
                setNoti(true);
            })
            .catch(async error => {
                if (error.response?.status === 401) {
                    await dispatch(refreshToken(getGeneralRateUpdate()))
                }
            })
    }
};



export const generalAutoRateUpdate = (requestBody, enqueueSnackbar, setNoti) => {

    return (dispatch) => {
        dispatch({
            type: IS_RATE_LOADING,
        });
        reposWebApi.post('/partner/pump_auto_rate_enable', requestBody, {
            headers: {
                Authorization: 'Bearer ' + localStorage.access_token
            }
        })
            .then(response => {
                dispatch({
                    type: GENERAL_AUTO_RATE_UPDATE,
                    payload: response?.data?.data,
                })
                enqueueSnackbar(response?.data?.data?.message, {
                    variant: 'success', anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    preventDuplicate: true
                });
                if (setNoti) setNoti();
            })
            .catch(async error => {
                if (error.response?.status === 401) {
                    await dispatch(refreshToken(generalAutoRateUpdate()))
                }
            })
    }
};